const HisSearch = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 18.3737C15.4183 18.3737 19 14.9099 19 10.6371C19 6.36421 15.4183 2.90039 11 2.90039C6.58172 2.90039 3 6.36421 3 10.6371C3 14.9099 6.58172 18.3737 11 18.3737Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0004 20.3084L16.6504 16.1016"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 7.73633V13.5388"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.6387H14"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisSearch;
